import React, { useEffect } from 'react';

import Divider from 'antd/es/divider';
import List from 'antd/es/list';
import message from 'antd/es/message';

import { Row, Col } from 'components/layout';
import Button from 'components/Button';

import ScheduleSection from '../components/ScheduleSection';
import ScheduleStepTitle from '../components/ScheduleStepTitle';
import { PeriodDateRangePicker } from '../components/PeriodDatePicker';
import ScheduleShift from '../components/ScheduleShift';

const ScheduleDetailsStep = ({ schedule, shifts, setSchedule, setShifts, setBeforeNext }) => {
  useEffect(() => {
    setBeforeNext(() => {
      if (!schedule.valid_from) {
        message.error('Please select the start date of this schedule');
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedule]);

  if (!schedule) return null;

  return (
    <Row>
      <Col span={24}>
        <ScheduleStepTitle
          title="Schedule details"
          description="First add the availability period and then add shifts with start/end time for each shift on specific days"
          style={{ padding: '16px 0' }}
        />
      </Col>
      <Col span={24}>
        <ScheduleSection title="Period Availability" style={{ paddingBottom: '48px' }}>
          <PeriodDateRangePicker
            value={[schedule.valid_from, schedule.valid_to]}
            onChange={([start, end]) => {
              setSchedule({ ...schedule, valid_from: start, valid_to: end });
            }}
          />
        </ScheduleSection>
        <ScheduleSection title="Shift Hours">
          <Divider type="horizontal" style={{ margin: 0 }} />
          <List
            dataSource={shifts}
            pagination={false}
            split={true}
            renderItem={(shift, index) => (
              <List.Item key={shift.shift_name}>
                <ScheduleShift
                  shift={shift}
                  onShiftChanged={value => {
                    setShifts(shifts => shifts.map((shift, idx) => {
                      if (idx === index) {
                        return value;
                      }
                      return shift;
                    }));
                  }}
                  onShiftRemoved={() => {
                    setShifts(shifts => {
                      return shifts
                        .filter((_, idx) => idx !== index)
                        .map((s, idx) => {
                          s.shift_name = `${idx + 1}`;
                          return s;
                        });
                    }); 
                  }}
                  canBeRemoved={shifts.length > 1}
                />
              </List.Item>
            )}
          />
          <Divider type="horizontal" style={{ margin: 0 }} />
          <Button
            type="default"
            icon={{ name: 'plus', size: 16 }}
            style={{ margin: '16px 0' }}
            onClick={() => {
              setShifts(shifts => [
                ...shifts,
                {
                  shift_name: `${shifts.length + 1}`,
                  workHours: [{
                    start_hr: null,
                    end_hr: null,
                    workday: null,
                  }],
                  breakHours: [],
                }
              ]);
            }}
          >
            Add Shift
          </Button>
        </ScheduleSection>
      </Col>
    </Row>
  );
};

export default ScheduleDetailsStep;
